// import React, { useContext, useState } from "react";
// import { Link } from "react-router-dom";
// import { AuthContext } from "../context/AuthContext";
// import "../Styles/Navbar.css";
// import { IoIosSend } from "react-icons/io";
// import { FaCalendarAlt } from "react-icons/fa";
// // import Logo from "../Assets/logo.png";
// import Logo from "./Fusionxe";

// function Navbar() {
//   const { isAuthenticated, user } = useContext(AuthContext);
//   const [isOpen, setIsOpen] = useState(false);

//   const toggleMenu = () => {
//     setIsOpen(!isOpen);
//   };

//   return (
//     <div className="Navbar">
//       <div className="Nav-right">
//         <Link className="logo" to={"./"}>
//           <div className="logo">
//             <Logo />
//           </div>
//         </Link>
//       </div>

//       <div className="nav-center">
//         <div>
//           <div>
//             <Link
//               to={"/inquiry"}
//               style={{ color: "white", textDecoration: "none" }}
//             >
//               Send Inquiry
//               <IoIosSend />
//             </Link>
//           </div>
//           <p>or</p>
//           <div>
//             <Link
//               to={"https://calendly.com/cmwenda20"}
//               style={{ color: "white", textDecoration: "none" }}
//             >
//               Book a Free Appointment
//               <FaCalendarAlt />
//             </Link>
//           </div>
//         </div>

//         <div>
//           <p>
//             {/* {isAuthenticated
//               ? `Logged in as
//               ${user?.name || user?.email}`
//               : "Logged in as a guest"} */}
//           </p>
//         </div>
//       </div>
//       <div className={`Nav-left ${isOpen ? "show" : ""}`}>
//         <div className="navlinks">
//           <div>
//             <Link to={"./"} onClick={() => setIsOpen(false)}>
//               Home
//             </Link>
//           </div>
//           <div>
//             <Link to={"About"} onClick={() => setIsOpen(false)}>
//               About
//             </Link>
//           </div>
//           <div>
//             <Link to={"Products"} onClick={() => setIsOpen(false)}>
//               Our Products
//             </Link>
//           </div>
//           <div>
//             <Link to={"Clients"} onClick={() => setIsOpen(false)}>
//               Our Clients
//             </Link>
//           </div>
//           <div>
//             <Link to={"Services"} onClick={() => setIsOpen(false)}>
//               Our Services
//             </Link>
//           </div>
//           <div>
//             <Link
//               to={"https://trendygadgetske.com/"}
//               onClick={() => setIsOpen(false)}
//             >
//               Shop With Us
//             </Link>
//           </div>
//         </div>
//       </div>
//       <div
//         className={`hamburger ${isOpen ? "change" : ""}`}
//         onClick={toggleMenu}
//       >
//         <div className="bar1"></div>
//         <div className="bar2"></div>
//         <div className="bar3"></div>
//       </div>
//     </div>
//   );
// }

// export default Navbar;

import React, { useContext, useState } from "react";
import { Link } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import "../Styles/Navbar.css";
import { IoIosSend } from "react-icons/io";
import { FaCalendarAlt } from "react-icons/fa";
import Logo from "./Fusionxe";
import FusionXeLogo from "../components/FusionXeLogo";



function Navbar() {
  const { isAuthenticated, user } = useContext(AuthContext);
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="Navbar">
      <div className="Nav-right">
        <Link className="logo-container" to={"./"}>
          <Logo className="logo" />
        </Link>
      </div>

      <div className="nav-center">
        <div className="nav-text">
          <Link to={"/inquiry"} className="nav-link">
            Send Inquiry <IoIosSend />
          </Link>
          <p>or</p>
          <Link to={"https://calendly.com/cmwenda20"} className="nav-link">
            Book a Free Appointment <FaCalendarAlt />
          </Link>
        </div>
      </div>

      <div className={`Nav-left ${isOpen ? "show" : ""}`}>
        <div className="navlinks">
          <Link to={"./"} onClick={() => setIsOpen(false)}>
            Home
          </Link>
          <Link to={"About"} onClick={() => setIsOpen(false)}>
            About
          </Link>
          <Link to={"Products"} onClick={() => setIsOpen(false)}>
            Our Products
          </Link>
          <Link to={"Clients"} onClick={() => setIsOpen(false)}>
            Our Clients
          </Link>
          <Link to={"Services"} onClick={() => setIsOpen(false)}>
            Our Services
          </Link>


          <Link to={"Contact"} onClick={() => setIsOpen(false)}>
            Our Cotacts
          </Link>
          <Link
            to={"https://kibandaskii.vercel.app/"}
            onClick={() => setIsOpen(false)}
          >
            Shop With Us
          </Link>
        </div>
      </div>

      <div
        className={`hamburger ${isOpen ? "change" : ""}`}
        onClick={toggleMenu}
      >
        <div className="bar1"></div>
        <div className="bar2"></div>
        <div className="bar3"></div>
      </div>
    </div>
  );
}

export default Navbar;
